/* eslint-disable react/no-unknown-property */

import React from 'react'

const CorporateIcon = ({ color = '#999FAC' }) => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
<path d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196 17.021 0 16.55 0 16V2C0 1.45 0.196 0.979 0.588 0.587C0.979333 0.195667 1.45 0 2 0H8C8.55 0 9.021 0.195667 9.413 0.587C9.80433 0.979 10 1.45 10 2V4H18C18.55 4 19.021 4.19567 19.413 4.587C19.8043 4.979 20 5.45 20 6V16C20 16.55 19.8043 17.021 19.413 17.413C19.021 17.8043 18.55 18 18 18H2ZM2 16H4V14H2V16ZM2 12H4V10H2V12ZM2 8H4V6H2V8ZM2 4H4V2H2V4ZM6 16H8V14H6V16ZM6 12H8V10H6V12ZM6 8H8V6H6V8ZM6 4H8V2H6V4ZM10 16H18V6H10V8H12V10H10V12H12V14H10V16ZM14 10V8H16V10H14ZM14 14V12H16V14H14Z" fill="#999FAC"/>
</svg>
)

export default CorporateIcon
